
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/news/article/[slug]",
      function () {
        return require("private-next-pages/[lang]/news/article/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/news/article/[slug]"])
      });
    }
  